module.exports = __webpack_public_path__ + "img/BlackMetallic_A.19390bd2.png";